import script from "./addProduct.vue?vue&type=script&lang=ts&setup=true"
export * from "./addProduct.vue?vue&type=script&lang=ts&setup=true"

import "./addProduct.vue?vue&type=style&index=0&id=67ff510f&lang=scss"

const __exports__ = script;

export default __exports__